import { InputHTMLElement } from "components/input/baseHTMLElementInput";
import template from "components/input/baseCheckboxInput.hbs";
import { Tooltip } from "components/components/tooltip/tooltip";


export class CheckboxInputElement extends InputHTMLElement {

  constructor() {
    super();

    const optTemplate = {
      "prefixId": "cbi",
      "id": this.getAttribute("_id"),
      "className": "c-checkbox-input__input",
      "disableFocusKeyboard": (this.getAttribute("disableFocusKeyboard") === 'true'),
      "style": this.getAttribute("_style")
    } as any;

    this.innerHTML = template(optTemplate);

    this.input = this.querySelector("input");

    this.bindEvents();
    Tooltip.bindElement(this);
  }

  private bindEvents(): void {
    this.genericBindEvents();
  }

  public set data(v: boolean) {
    this.input.checked = (v === true);
    this.initialValue.value = this.data;
  }

  public get data(): boolean {
    return this.input.checked;
  }
}

export function initCheckboxInputWebComponent() {
  window.customElements.define("s6-checkbox-input", CheckboxInputElement);
}
